/* unplugin-vue-components disabled */import { render } from "./KilaKilaFormCard.vue?vue&type=template&id=219dcf4a&scoped=true"
import script from "./KilaKilaFormCard.vue?vue&type=script&lang=js"
export * from "./KilaKilaFormCard.vue?vue&type=script&lang=js"

import "./KilaKilaFormCard.vue?vue&type=style&index=0&id=219dcf4a&scoped=true&lang=css"

import exportComponent from "E:\\Jweb\\结课作业\\KilaKila-Blog\\kilakila-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219dcf4a"]])

export default __exports__